export default {
  DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
  DUPLICATE_USERNAME: 'DUPLICATE_USERNAME',
  INVALID_EMAIL: 'INVALID_EMAIL',
  INVALID_KEY: 'INVALID_KEY',
  INVALID_ORGANIZATION: 'INVALID_ORGANIZATION',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  INVALID_USERNAME: 'INVALID_USERNAME',
  INVALID_VALUE: 'INVALID_VALUE',
  MISSING_EMAIL: 'MISSING_EMAIL',
  MISSING_ORGANIZATIONID: 'MISSING_ORGANIZATIONID',
  MISSING_PASSWORD: 'MISSING_PASSWORD',
  MISSING_USERNAME: 'MISSING_USERNAME',
  NO_USER: 'NO_USER',
  UNKNOWN: 'UNKNOWN'
}
